<template>
  <div>
  <div class="circleHeight" v-show="showProduct">
    <van-row type="flex" justify="space-between" class="circleTitle">
      <van-col span="7">产品分析</van-col>
      <van-col span="15" class="buttonChange timeButton" v-show="showButton">
        <button :class="{ choose:1===type }" @click="changeType(1)" v-if="showRisk">险类维度</button>
        <button :class="{ choose:2===type }" @click="changeType(2)" v-if="showMain">主附维度</button>
      </van-col>
      <!-- <div @click="productClick"  class="toDetail">
        <van-col span="2">
          <img src="../../../../static/images/more.png" style="width:.1rem;height:.16rem">
        </van-col>
      </div> -->
    </van-row>
  </div>
    <div :style="{height:iframeHeight,overflow:'hidden',background:'#fff',paddingRight:'15px'}" v-show="showProduct">
      <van-row :style="{height:iframeHeight}" class="productClass">
        <div style="padding: 0;margin: 0">
          <form method="POST" id="formProduct" style="display: none;" target="iframeProduct">
            <input name="resid" type="text" value="">
            <input name="showtoolbar" type="text" value="false">
            <input name="paramsInfoBase64" type="text" value="">
          </form>
          <div :style="{height: iframeHeight}" id="iframeProductDiv">
            <iframe id="iframeProduct" name="iframeProduct" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>
          </div>
        </div>
      </van-row>
    </div>

  <div class="circleHeight" v-show="showStructure">
    <van-row type="flex" justify="space-between" class="circleTitle">
      <van-col span="8">结构分析</van-col>
      <!-- <div @click="structureClick" class="toDetail">
        <van-col span="16">
          <img src="../../../../static/images/more.png" style="width:.1rem;height:.16rem">
        </van-col>
      </div> -->
    </van-row>

  </div>
    <div :style="{height:iframeHeight,overflow:'hidden',background:'#fff',paddingRight: '15px'}" v-show="showStructure">
      <van-row :style="{height:iframeHeight}">
        <div style="padding: 0;margin: 0">
          <form method="POST" id="formStruct" style="display: none;" target="iframeStruct">
            <input name="resid" type="text" value="">
            <input name="showtoolbar" type="text" value="false">
            <input name="paramsInfoBase64" type="text" value="">
          </form>
          <div :style="{height: iframeHeight}" id="iframeStructDiv">
            <iframe id="iframeStruct" name="iframeStruct" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>
          </div>
        </div>

      </van-row>
    </div>
  </div>
</template>

<script>
import {ifrSrc, changeDay} from '@/utils/smartbi/dataComponent'
import { getAction } from '@/utils/api'
import {getSmartbiLeadFlag} from '@/utils/request'
import {promiseIsBatchFinish, getCurrentMonthLast} from '@/utils/util'
export default {
  name: 'SmartbiEntiretyPie',
  data () {
    return {
      type: 1,
      showProduct: false,
      showRisk: (this.$store.state.smartbi.hasProject) && (this.$store.state.smartbi.hasMainRisk), // 产品分析和主附维度都存在时
      showMain: (this.$store.state.smartbi.hasProject) && (this.$store.state.smartbi.hasMainRisk), // 产品分析和主附维度都存在时
      showButton: false, // 默认不显示险类主附按钮，当只有一项选择的时候不显示,
      iframeHeight: '',
      time: 2, // 默认时间显示为月
      showStructure: false, // 默认显示结构分析
      product: false, // 产品分析默认为false
      structure: false // 结构分析默认为false
    }
  },
  props: ['chooseDateValue'],
  watch: {
    // 年月日发生改变时
    getTime () {
      this.$nextTick(() => {
        this.time = this.$store.state.entirety.time
        var that = this
        new Promise(promiseIsBatchFinish).then(function () {
          that.getProductIframe()
          that.getStructIframe()
        })
      })
    },
    // // 渠道发生改变时
    // getChannel () {
    //   this.$nextTick(() => {
    //     var that = this
    //     new Promise(promiseIsBatchFinish).then(function (data) {
    //       that.getProductIframe()
    //       that.getStructIframe()
    //     })
    //   })
    // },
    // 时间控件选择时间时
    chooseDateValue () {
      this.$nextTick(() => {
        var that = this
        new Promise(promiseIsBatchFinish).then(function (data) {
          that.getProductIframe()
          that.getStructIframe()
        })
      })
    }
    // getChannelq () {
    //   // 从关注或者搜索进入,在detailHeader.vue里面保存了ENTIRETY_SET_CHANNEL_QUOTA，
    //   if (this.$store.state.entirety.channelQuota.length !== 0) {
    //     this.getQuota()
    //   }
    // }
  },
  computed: {
    // 当年月日发生改变时
    getTime () {
      return this.$store.state.entirety.time
    }
    // // 当渠道发生改变时
    // getChannel () {
    //   return this.$store.state.entirety.channel
    // },
    // getChannelq () {
    //   return this.$store.state.entirety.channelQuota
    // }
  },
  methods: {
    // 依据地址所携带的指标数据，获取指标字段是否显示信息
    getQuota () {
      // 导入指标不显示产品分析和结构分析
      if (this.$route.query.indexId.charAt(0) === 'B') {
        return
      }
      var getPostdata = {
        moduleId: this.$route.query.moduleId,
        indexId: this.$route.query.indexId,
        channelId: this.$route.query.channelId
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        let resData = res.data
        this.showFlag = resData
        this.unit = resData.unit
        this.$store.commit('SMARTBI_UNIT', this.unit)
        this.$store.commit('SMARTBI_HAS_BANK', resData.hasBank)
        this.$store.commit('SMARTBI_HAS_MAIN_RISK', resData.hasMainRisk)
        this.$store.commit('SMARTBI_HAS_PROJECT', resData.hasProject)
        this.$store.commit('SMARTBI_HAS_RISK_HUMAN', resData.hasRiskHuman)
        this.$store.commit('SMARTBI_HAS_RISK_HELTH', resData.hasRiskHelth)
        this.$store.commit('SMARTBI_HAS_REGULAR', resData.hasRegular)
        this.$store.commit('SMARTBI_HAS_STRU', resData.hasStru)
        this.$store.commit('SMARTBI_HAS_STRU_WORKYREAR', resData.hasStruWorkyear)
        this.$store.commit('SMARTBI_INDEX_DAY', resData.indexDay)
        this.$store.commit('SMARTBI_INDEX_MONTH', resData.indexMonth)
        this.$store.commit('SMARTBI_INDEX_YEAR', resData.indexYear)
        this.$store.commit('SMARTBI_REAL_TIME', resData.realTime)
        this.$store.commit('SMARTBI_CAL', resData.cal)
        this.$store.commit('SMARTBI_IS_PRE_ENTRY', resData.isPreEntry)
        this.$store.commit('SMARTBI_START_TIME', resData.startTime)
        console.log('showDimension请求完毕')
        this.getQuotaDeail()
      })
    },
    // 点击切换主附、险类维度
    changeType (val) {
      this.type = val
      var that = this
      new Promise(promiseIsBatchFinish).then(function (data) {
        that.getProductIframe()
      })
    },
    // 点击跳转到产品分析详情
    productClick () {
      localStorage.setItem('analyseName', '产品分析')
      this.$store.commit('ENTIRETY_SET_TABLETYPE', 1)
      // 1、险类维度 2、主附维度  3、短期健康险/非健康险
      this.$store.commit('USER_SET_PRODUCT_TYPE', this.type)
      this.$router.push({
        path: '/entiretyProduct',
        query: {
          passTimeDate: localStorage.getItem('passTimeDate'),
          passCurrentDate: localStorage.getItem('passCurrentDate')
        }
      })
    },
    structureClick () {
      localStorage.setItem('analyseName', '结构分析')
      this.$store.commit('ENTIRETY_SET_TABLETYPE', 2)
      this.$router.push({
        path: '/entiretyProduct',
        query: {
          passTimeDate: localStorage.getItem('passTimeDate'),
          passCurrentDate: localStorage.getItem('passCurrentDate')
        }
      })
    },
    // 产品分析饼图
    getProductIframe () {
      if (!this.product) {
        return
      }
      // 报表reSid
      var resid = ifrSrc.hollowPieResid
      // 当时间为月年的时候拼sql，并显示产品分析
      switch (Number(this.time)) {
        case 2:
          this.showProduct = true
          break
        case 3:
          this.showProduct = true
          break
        default:
          this.showProduct = false
      }
      var nowDate = new Date()
      var dateTimeStr = this.chooseDateValue
      if (this.chooseDateValue === null || this.chooseDateValue === '') {
        dateTimeStr = String(nowDate.getFullYear()) + String(changeDay(nowDate.getMonth() + 1)) + String(changeDay(nowDate.getDate()))
      } else if (this.chooseDateValue.length === 6 || this.$store.state.smartbi.realTime === 0) {
        var chooseDate = this.chooseDateValue.slice(0, 4) + '-' + this.chooseDateValue.slice(4, 6)
        chooseDate = new Date(chooseDate)
        if (chooseDate.getFullYear() === nowDate.getFullYear() && chooseDate.getMonth() === nowDate.getMonth()) {
          dateTimeStr = String(nowDate.getFullYear()) + String(changeDay(nowDate.getMonth() + 1)) + String(changeDay(nowDate.getDate()))
        } else {
          dateTimeStr = getCurrentMonthLast(chooseDate)
        }
      }
      var areaFlag = this.$store.state.user.areaFlag
      var areaCode = this.$store.state.user.areaCode
      var channelCode = this.$store.state.entirety.channel
      var orgId = this.$store.state.user.orgId
      var level = this.$store.state.user.level
      var quota = this.$store.state.entirety.quota
      var moduleCode = this.$store.state.user.pageCode
      var chartMold = '1'
      var pieJsonParam = {
        'areaFlag': areaFlag + '',
        'areaCode': areaCode,
        'channel': channelCode,
        'indexCode': quota,
        'orgId': orgId,
        'level': level,
        'dateType': this.time + '',
        'chartMold': chartMold,
        'dimState': this.type + '',
        'moduleCode': moduleCode,
        'dateTime': dateTimeStr
      }
      var pramJson = {
        'name': 'pieJson',
        'value': pieJsonParam
      }
      var leadFlagpram = {
        leadFlag: getSmartbiLeadFlag()
      }
      var headerpram = {
        'name': 'header',
        'value': JSON.stringify(leadFlagpram)
      }
      var paramsInfo = []
      paramsInfo.push(pramJson)
      paramsInfo.push(headerpram)
      var param = JSON.stringify(paramsInfo)
      if (this.time !== 1) {
        let form = document.getElementById('formProduct')
        form.resid.value = resid
        form.paramsInfoBase64.value = btoa(unescape(encodeURIComponent(param)))
        if (document.getElementById('iframeProduct')) {
          document.getElementById('iframeProduct').remove()
        }
        document.getElementById('iframeProductDiv').innerHTML = '<iframe id="iframeProduct" name="iframeProduct" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>'
        form.action = ifrSrc.smartbiUrl
        form.submit()
      }
    },
    // 结构分析饼图
    getStructIframe () {
      if (!this.structure) {
        return
      }
      var resid = ifrSrc.solidPieResid
      // 司龄
      let hasStruWorkyear = this.$store.state.smartbi.hasStruWorkyear
      // 转正维度
      let hasRegular = this.$store.state.smartbi.hasRegular
      var quota = this.$store.state.entirety.quota
      if (hasStruWorkyear || hasRegular) {
        // 不分层级的饼图
        resid = ifrSrc.yejiBankResid
      }
      if (quota === 'T-A0102-1001' || quota === 'A0102-1051' || quota === 'Y0102-1051' || quota === 'A0102-1052' || quota === 'Y0102-1052' || quota === 'T-A0102-1007') {
        resid = ifrSrc.yejiBankResid
      }
      if (quota === 'T-A0102-1005' || quota === 'A0101-1010' || quota === 'A0101-1011' || quota === 'Y0101-1010' || quota === 'Y0101-1011') {
        resid = ifrSrc.yejiBankResid
      }
      switch (Number(this.time)) {
        case 2:
          this.showStructure = true
          break
        case 3:
          this.showStructure = true
          break
        default:
          this.showStructure = false
      }
      var nowDate = new Date()
      var dateTimeStr = this.chooseDateValue
      if (this.chooseDateValue === null || this.chooseDateValue === '') {
        dateTimeStr = String(nowDate.getFullYear()) + String(changeDay(nowDate.getMonth() + 1)) + String(changeDay(nowDate.getDate()))
      } else if (this.chooseDateValue.length === 6 || this.$store.state.smartbi.realTime === 0) {
        var chooseDate = this.chooseDateValue.slice(0, 4) + '-' + this.chooseDateValue.slice(4, 6)
        chooseDate = new Date(chooseDate)
        if (chooseDate.getFullYear() === nowDate.getFullYear() && chooseDate.getMonth() === nowDate.getMonth()) {
          dateTimeStr = String(nowDate.getFullYear()) + String(changeDay(nowDate.getMonth() + 1)) + String(changeDay(nowDate.getDate()))
        } else {
          dateTimeStr = getCurrentMonthLast(chooseDate)
        }
      }
      var areaFlag = this.$store.state.user.areaFlag
      var areaCode = this.$store.state.user.areaCode
      var channelCode = this.$store.state.entirety.channel
      var orgId = this.$store.state.user.orgId
      var level = this.$store.state.user.level
      var moduleCode = this.$store.state.user.pageCode
      var chartMold = '2'
      var pieJsonParam = {
        'areaFlag': areaFlag + '',
        'areaCode': areaCode,
        'channel': channelCode,
        'indexCode': quota,
        'orgId': orgId,
        'level': level,
        'dateType': this.time + '',
        'chartMold': chartMold,
        'dimState': this.type + '',
        'moduleCode': moduleCode,
        'dateTime': dateTimeStr
      }
      var pramJson = {
        'name': 'pieJson',
        'value': pieJsonParam
      }
      var leadFlagpram = {
        leadFlag: getSmartbiLeadFlag()
      }
      var headerpram = {
        'name': 'header',
        'value': JSON.stringify(leadFlagpram)
      }
      var paramsInfo = []
      paramsInfo.push(pramJson)
      paramsInfo.push(headerpram)
      var param = JSON.stringify(paramsInfo)
      if (this.time !== 1) {
        let form = document.getElementById('formStruct')
        form.resid.value = resid
        form.paramsInfoBase64.value = btoa(unescape(encodeURIComponent(param)))
        if (document.getElementById('iframeStruct')) {
          document.getElementById('iframeStruct').remove()
        }
        document.getElementById('iframeStructDiv').innerHTML = '<iframe id="iframeStruct" name="iframeStruct" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>'
        form.action = ifrSrc.smartbiUrl
        form.submit()
      }
    },
    getQuotaDeail () {
      this.unit = this.$store.state.smartbi.unit
      // 是否有产品分析
      let hasProject = this.$store.state.smartbi.hasProject
      // 是否有主附维度
      let hasMainRisk = this.$store.state.smartbi.hasMainRisk
      // 是否有险类维度
      let hasRiskHuman = this.$store.state.smartbi.hasRiskHuman
      // 是否有短期健康险/非健康险
      let hasRiskHelth = this.$store.state.smartbi.hasRiskHelth
      // 是否有结构分析
      let hasStru = this.$store.state.smartbi.hasStru
      let indexMonth = this.$store.state.smartbi.indexMonth
      // 指标没有月的分析时默认年的分析
      if (!indexMonth) {
        this.time = 3
      }
      // 产品分析
      switch (true) {
        // 没有产品分析
        case Boolean(!hasProject):
          this.product = false
          this.showProduct = false
          break
          // 短期健康险/非健康险(不显示产品分析按钮)
        case Boolean(hasRiskHelth):
          this.product = true
          this.showProduct = true
          this.showButton = false
          this.type = 3
          break
          // 主附维度，险类维度（显示产品分析维度切换按钮）
        case Boolean(hasRiskHuman && hasMainRisk && (!hasRiskHelth)):
          this.product = true
          this.showProduct = true
          this.showButton = true
          this.showMain = true
          this.showRisk = true
          this.type = 1
          break
        // 产品分析-1，不展示；0,人寿年金健康意外/主附；1，人寿年金健康意外；2，主附;3,短期健康险/非健康险
          //  险类维度（产品分析维度切换按钮不展示）
        case Boolean(hasRiskHuman && (!hasMainRisk) && (!hasRiskHelth)):
          this.product = true
          this.showProduct = true
          this.showButton = false
          this.type = 1
          break
        // 只有主附（产品分析维度切换按钮不展示）
        case Boolean(hasMainRisk && (!hasRiskHuman) && (!hasRiskHelth)):
          this.product = true
          this.showProduct = true
          this.showButton = false
          this.type = 2
          break
      }
      // 结构分析
      if (hasStru) {
        this.structure = true
        this.showStructure = true
      } else {
        this.structure = false
        this.showStructure = false
      }
      var that = this
      new Promise(promiseIsBatchFinish).then(function (data) {
        that.getProductIframe()
        that.getStructIframe()
      })
    }
  },
  created () {
    // 获取当前指标smartbi所需的字段值
    this.getQuota()
  },
  mounted () {
    var width = document.body.clientWidth
    var height = 351 / 527 * (width - 15)
    this.iframeHeight = height + 'px'
  }
}
</script>

<style scoped>
  /*.productClass{*/
  /*  -webkit-overflow-scrolling: touch;*/
  /*  overflow: scroll;*/
  /*}*/
  .circleHeight {
    margin-top: 0.1rem;
    padding: 0px 15px 15px 15px;
    background: #fff;
    /*position: relative;*/
    /*z-index: 1;*/
  }

  .circleTitle {
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
    /*position: relative;*/
    /*z-index: 99999999999;*/
  }

  .circle{
    padding-top: 0.1rem;
  }
  .circle p{
    color: #333;
    font-size: 0.12rem;
    line-height: 0.4rem;
  }
  .circle p span {
    display: inline-block;
    margin: 0px 5px;
    color: #999;
  }
  .circle p label {
    display: inline-block;
    width: .15rem;
    height: .15rem;
    border-radius: 50%;
    vertical-align: middle
  }

  .buttonChange {
    font-size: 0;
    text-align: right;
  }

  .buttonChange button {
    height: 0.26rem;
    line-height: 0.26rem;
    border: none;
    margin: 0;
    font-size: 0;
    font-size: 0.14rem;
    padding: 0 15px;
    color: #39f;
    background: none;
    border: 1px solid #39f;
    border-radius: 0.02rem;
  }

  .timeButton button {
    border: 1px solid #F2F2F2;
    color: #999;
  }

  .buttonChange .choose {
    background: #3399FF;
    border: 1px solid #3399FF;
    color: #fff;
    border-radius: 0.02rem;
  }
  .toDetail{
    padding-left: 0.2rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/SmartbiEntiretyPie.vue